import React, { useEffect, useState } from 'react';
import {
  get_user_info,
  getMyProfileRequest,
  kudosListRequest,
  getFeatureListRequest
} from '../../../helpers/api';
import { useHistory } from 'react-router-dom';
import { routes } from '../../../assets/routes';
import { useDispatch } from 'react-redux';
import {
  setHeaderConfigsAction,
  setHeaderTitleAction
} from '../../../reactRedux/Actions/headerAction';
import styles from './styles.module.scss';
import {
  Coin,
  Email,
  Instagram,
  Linkedin,
  MoneyBag,
  Phone,
  Skype,
  Telegram,
  Whatsapp
} from '../../../assets/icons/iconComponents2';
import SimpleTabs from '../../common/tabs/SimpleTabs';
import StyledTab from '../../common/tabs/SimpleTab';
import {
  a11yProps,
  addExtraBackButtonControls,
  toLatinDigits
} from '../../../helpers/utils';
import { Backdrop, useScrollTrigger } from '@material-ui/core';
import TabPanel from '../../common/tabs/SimpleTabPanel';
import KudosCard from '../../common/cards/KudosCard';
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import AddRoundedIcon from '@material-ui/icons/AddRounded';
import { parseDate, presentationBirthday } from '../../../helpers/date';
import Loader from '../../common/Loader';
import { toast } from 'react-toastify';
import AvatarReco from '../../common/AvatarReco';
import classNames from 'classnames';
import Skeleton from '../../common/Skeleton';
import { Helmet } from 'react-helmet';
import { toggleBackButtonAction } from '../../../reactRedux/Actions/sideBarAction';
import SwipeableViews from 'react-swipeable-views';
import Eof from '../../common/Eof';
import { modules } from '../../../helpers/modules';
import PropTypes from 'prop-types';
import { useInfiniteQuery, useMutation, useQuery } from '@tanstack/react-query';
import { getUserProfileRequest, postUserRate } from './api';
import Button from '@mui/material/Button';
import { Rating } from '@mui/material';
import InfiniteScroll from 'react-infinite-scroll-component';
import BackToTopButton from '../../common/BackToTopButton';
import { useTranslation } from '../../../i18n/LanguageProvider';

const Profile = (props) => {
  const { t, isRtl } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();

  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 30,
    // MARK: why is this prop named window (it may clash with the global object)
    target: props.window ? props.window() : undefined
  });

  const myId = get_user_info()?.id.toString();
  const [favIndex, setFavIndex] = useState(0);
  const [tabIndex, setTabIndex] = useState(0);
  const [userId] = useState(props.location.pathname.slice(1).split('/')[1]);
  const [userInfo, setUserInfo] = useState({});
  const [userPersonalityCount, setUserPersonalityCount] = useState([]);
  const [userInfoLoading, setUserInfoLoading] = useState(true);
  const [openImage, setOpenImage] = useState(false);
  const [enabledMyProfile, setEnabledMyProfile] = useState(false);

  const setHeader = (title) => dispatch(setHeaderTitleAction(title));
  const setHeaderConfigs = (configs) =>
    dispatch(setHeaderConfigsAction(configs));
  const setSideBarBackButton = (show) => dispatch(toggleBackButtonAction(show));

  const {
    isLoading: givenKudosIsLoading,
    data: givenKudosData,
    hasNextPage: givenKudosHasNextPage,
    fetchNextPage: givenKudosFetchNextPage,
    isFetchingNextPage: givenKudosIsFetchingNextPage,
    isFetching: givenKudosIsFetching
  } = useInfiniteQuery(
    ['kudos', 'list', 'given', userId],
    ({ pageParam = null }) =>
      kudosListRequest({
        last_id: pageParam,
        received_kudos: false,
        given_kudos: true,
        user_id: userId
      }),
    {
      getNextPageParam: (lastPage) => {
        const lastIndex = lastPage.data.length - 1;
        const lastId = lastPage.data[lastIndex]?.id;
        return lastPage.data.length !== 0 ? lastId : undefined;
      },
      select: React.useCallback(
        (data) => data?.pages.flatMap((kudos) => kudos.data),
        []
      ),
      onError(err) {
        toast.error(err.response?.data?.detail);
      },
      enabled: tabIndex === 1
    }
  );

  const {
    isLoading: receivedKudosIsLoading,
    data: receivedKudosData,
    hasNextPage: receivedKudosHasNextPage,
    fetchNextPage: receivedKudosFetchNextPage,
    isFetchingNextPage: receivedKudosIsFetchingNextPage,
    isFetching: receivedKudosIsFetching
  } = useInfiniteQuery(
    ['kudos', 'list', 'received', userId],
    ({ pageParam = null }) =>
      kudosListRequest({
        last_id: pageParam,
        received_kudos: true,
        given_kudos: false,
        user_id: userId
      }),
    {
      getNextPageParam: (lastPage) => {
        const lastIndex = lastPage.data.length - 1;
        const lastId = lastPage.data[lastIndex]?.id;
        return lastPage.data.length !== 0 ? lastId : undefined;
      },
      select: React.useCallback(
        (data) => data?.pages.flatMap((kudos) => kudos.data),
        []
      ),
      onError(err) {
        toast.error(err.response?.data?.detail);
      },
      enabled: tabIndex === 0
    }
  );

  const { isLoading: rateUserIsLoading, data: rateUser } = useQuery(
    ['featureList'],
    getFeatureListRequest,
    {
      select(data) {
        return data.data.filter(
          (value) => value.feature_name === 'rate_user'
        )[0].active;
      }
    }
  );

  const profileQuery = useQuery(
    ['profile', userId],
    () => getUserProfileRequest(userId),
    {
      onSuccess(response) {
        setUserInfoLoading(false);
        setUserInfo(response.data);

        setUserPersonalityCount([
          { type: 'skills', value: !!response.data.skills?.length },
          { type: 'favorites', value: !!response.data.favorites?.length },
          { type: 'wishes', value: !!response.data.wishes?.length }
        ]);
      },
      enabled: !enabledMyProfile,
      onError(err) {
        toast.error(err.response?.data?.detail);
      }
    }
  );

  useQuery(['myProfile'], getMyProfileRequest, {
    onSuccess(response) {
      if (enabledMyProfile) {
        setUserInfoLoading(false);
        setUserInfo(response);
        setUserPersonalityCount([
          { type: 'skills', value: true },
          { type: 'favorites', value: true },
          { type: 'wishes', value: true }
        ]);
      }
    },
    enabled: enabledMyProfile,
    onError(err) {
      toast.error(err.response?.data?.detail);
    }
  });

  const postUserScoreMutation = useMutation({
    mutationFn: postUserRate,
    onError(err) {
      toast.error(err.response?.data?.detail);
    },

    onSuccess: () => {
      toast.success(t('profile.rateSubmitted'));
      profileQuery.refetch();
    }
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (userId !== myId) {
      setSideBarBackButton(true);

      return () => setSideBarBackButton(false);
    }
  }, []);

  useEffect(() => {
    addExtraBackButtonControls({
      data: openImage,
      func: () => setOpenImage(false)
    });

    return () => addExtraBackButtonControls({});
  }, [openImage]);

  useEffect(() => {
    if (trigger) {
      setHeader(
        userInfo.first_name
          ? `${userInfo.first_name} ${userInfo.last_name}`
          : ''
      );
    } else {
      setHeader(t('profile.title'));
    }
  }, [trigger]);

  useEffect(() => {
    setHeader(t('profile.title'));
    setHeaderConfigs({
      credits: false,
      settings: userId === myId,
      back: userId !== myId,
      logo: false
    });
    userId === myId && setEnabledMyProfile(true);
  }, []);

  const handleFavChange = (event, newValue) => {
    setFavIndex(newValue);
  };

  const handleChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const handleChangeFavIndex = (index) => {
    setFavIndex(index);
  };

  const handleChangeIndex = (index) => {
    setTabIndex(index);
  };

  const closeImage = () => {
    setOpenImage(false);
    history.goBack();
    document.body.style.overflowY = 'revert';
  };

  const giveKudos = () => {
    const user = {
      id: +userId,
      name: `${userInfo.first_name} ${userInfo.last_name}`,
      img: userInfo.avatar?.thumbnail
    };
    history.push(routes.GIVE_KUDOS, modules.group_reco ? [user] : user);
  };

  const personalityTemplate = (index, type) => {
    let personalityList;
    let empty = '';
    if (type === 'skills') {
      if (userInfo.skills.length) {
        personalityList = userInfo.skills;
      } else {
        empty = t('profile.noSkills');
      }
    } else if (type === 'favorites') {
      if (userInfo.favorites.length) {
        personalityList = userInfo.favorites;
      } else {
        empty = t('profile.noFavorites');
      }
    } else if (type === 'wishes') {
      if (userInfo.wishes.length) {
        personalityList = userInfo.wishes;
      } else {
        empty = t('profile.noWishes');
      }
    }

    return (
      <TabPanel key={index} index={index} value={favIndex}>
        {empty ? (
          <p className={styles.emptyPersonalityBody}>{empty}</p>
        ) : (
          <ul className={classNames(styles.body, styles.personalityBody)}>
            {personalityList.map((p, i) => (
              <li key={i}>{p}</li>
            ))}
          </ul>
        )}
      </TabPanel>
    );
  };

  return (
    <div className={styles.page}>
      <BackToTopButton value={1500} />
      <Helmet>
        <title>{t('profile.title')}</title>
      </Helmet>
      <div className={styles.info}>
        <span className={styles.circle} />
        <div className={styles.top}>
          <div className={styles.imgWrapper}>
            <AvatarReco
              avatar={userInfo.avatar}
              size={12}
              onClick={() => {
                setOpenImage(true);
                window.history.pushState(null, null, window.location.pathname);
                document.body.style.overflowY = 'hidden';
              }}
            />
          </div>
        </div>
        <div className={styles.edit}>
          {userId === myId ? (
            <Button
              variant={'outlined'}
              size="small"
              endIcon={<EditRoundedIcon />}
              onClick={() => history.push(routes.EDIT)}
            >
              {t('common.edit')}
            </Button>
          ) : (
            <Button
              variant={'contained'}
              size="small"
              color="secondary"
              onClick={giveKudos}
              endIcon={<AddRoundedIcon />}
              className={styles.kudosBtn}
            >
              {t('profile.giveKudosTo', { name: userInfo.first_name })}
            </Button>
          )}
        </div>
        {userInfoLoading ? (
          <div className={styles.loader}>
            <Skeleton width={100} />
            <Skeleton lines={2} width={50} />
            <Skeleton width={200} big />
          </div>
        ) : (
          <>
            <span className={styles.name}>
              {userInfo.first_name} {userInfo.last_name}
            </span>
            {!!userInfo.job_title && (
              <span className={styles.job}>{userInfo.job_title}</span>
            )}
            {!!userInfo.organization_department && (
              <span className={styles.department}>
                {t('profile.department', {
                  name: userInfo.organization_department.name
                })}
              </span>
            )}
            <div className={styles.social}>
              {!!userInfo.phone_repr && (
                <a
                  className={styles.iconWrapper}
                  href={`tel:${toLatinDigits(userInfo.phone_repr)}`}
                >
                  <Phone />
                </a>
              )}
              {!!userInfo.gmail && (
                <a
                  className={styles.iconWrapper}
                  href={`mailto:${userInfo.gmail}`}
                >
                  <Email />
                </a>
              )}
              {!!userInfo.whatsapp && (
                <a
                  className={styles.iconWrapper}
                  target="_blank"
                  rel="noreferrer"
                  href={userInfo.whatsapp}
                >
                  <Whatsapp />
                </a>
              )}
              {!!userInfo.telegram && (
                <a
                  className={styles.iconWrapper}
                  target="_blank"
                  rel="noreferrer"
                  href={userInfo.telegram}
                >
                  <Telegram />
                </a>
              )}
              {!!userInfo.skype && (
                <a
                  className={styles.iconWrapper}
                  target="_blank"
                  rel="noreferrer"
                  href={userInfo.skype}
                >
                  <Skype />
                </a>
              )}
              {!!userInfo.linkedin && (
                <a
                  className={styles.iconWrapper}
                  target="_blank"
                  rel="noreferrer"
                  href={userInfo.linkedin}
                >
                  <Linkedin />
                </a>
              )}
              {!!userInfo.instagram && (
                <a
                  className={styles.iconWrapper}
                  target="_blank"
                  rel="noreferrer"
                  href={userInfo.instagram}
                >
                  <Instagram />
                </a>
              )}
            </div>
          </>
        )}
        {userId === myId && (
          <div className={styles.credit}>
            <div>
              <div>
                <Coin />
                <span>{t('common.scoreLabel')}</span>
              </div>
              <span>{userInfo?.score ?? '-'}</span>
            </div>
            <div>
              <div>
                <MoneyBag />
                <span>{t('common.creditLabel')}</span>
              </div>
              <span>{userInfo.credit ?? '-'}</span>
            </div>
          </div>
        )}

        {modules.about_me_score &&
          userId === myId &&
          !!userInfo?.about &&
          rateUser &&
          !rateUserIsLoading && (
            <div className={styles.score}>
              <div>
                <div>
                  <span>{t('profile.profileScore')}</span>
                </div>
                {userInfo?.average_about_me_rate !== null ? (
                  <span>{userInfo?.average_about_me_rate || 0} / 5</span>
                ) : (
                  <span>{t('profile.noProfileScore')}</span>
                )}
              </div>
              {userInfo?.average_about_me_rate !== null && (
                <Rating
                  readOnly
                  name="half-rating"
                  value={userInfo?.average_about_me_rate}
                  precision={0.1}
                />
              )}
            </div>
          )}

        {modules.about_me_score &&
          userId !== myId &&
          !!userInfo?.about &&
          rateUser &&
          !rateUserIsLoading && (
            <div className={styles.score}>
              <div>
                <div>
                  <span>
                    {t('profile.rateProfile', { name: userInfo.first_name })}
                  </span>
                </div>
              </div>

              <Rating
                value={userInfo?.average_about_me_rate || 0}
                onChange={(_, value) =>
                  postUserScoreMutation.mutate({
                    rate: value,
                    recieverId: userId
                  })
                }
                precision={1}
                sx={{
                  'input:checked + label': {
                    background: 'transparent'
                  }
                }}
              />
            </div>
          )}
      </div>
      <div className={styles.userInfo}>
        {userInfoLoading && (
          <div className={styles.container}>
            <div className={styles.title}>{t('profile.aboutMe')}</div>
            <div className={styles.body}>
              <Skeleton lines={3} />
            </div>
          </div>
        )}
        {!userInfoLoading &&
          (userInfo.birthday || userInfo.about || userId === myId) && (
            <div className={styles.container}>
              <div className={styles.title}>{t('profile.aboutMe')}</div>
              <div className={styles.body}>
                {!!userInfo?.birthday && (
                  <span style={{ fontWeight: 'bold' }}>
                    {userInfo?.show_my_birthday ? (
                      <span>
                        {' '}
                        {t('profile.born', {
                          date: parseDate(userInfo.birthday, true)
                        })}
                      </span>
                    ) : (
                      <span>
                        {t('profile.born', {
                          date: presentationBirthday(userInfo.birthday)
                        })}
                      </span>
                    )}
                  </span>
                )}
                <span dir="auto">
                  {userInfo?.about
                    ? userInfo.about
                    : userId === myId
                    ? t('profile.noAbout')
                    : null}
                </span>
              </div>
            </div>
          )}
        {userInfoLoading && (
          <div className={styles.container}>
            <div className={classNames(styles.section, styles.w100)}>
              <div
                className={classNames(
                  styles.sectionTop,
                  styles.personalityTabs
                )}
              >
                <Skeleton width={50} />
                <Skeleton width={50} />
                <Skeleton width={50} />
              </div>
              <div className={styles.sectionBody}>
                <Skeleton width={100} lines={3} />
              </div>
            </div>
          </div>
        )}
        {(!!userInfo.skills?.length ||
          !!userInfo.favorites?.length ||
          !!userInfo.wishes?.length ||
          userId === myId) &&
          !userInfoLoading && (
            <div className={styles.container}>
              <div className={classNames(styles.section, styles.w100)}>
                <div
                  className={classNames(
                    styles.sectionTop,
                    styles.personalityTabs
                  )}
                >
                  <SimpleTabs value={favIndex} handleChange={handleFavChange}>
                    {(!!userInfo.skills?.length || userId === myId) && (
                      <StyledTab
                        label={t('profile.skills')}
                        {...a11yProps(0)}
                      />
                    )}
                    {(!!userInfo.favorites?.length || userId === myId) && (
                      <StyledTab
                        label={t('profile.favorites')}
                        {...a11yProps(1)}
                      />
                    )}
                    {(!!userInfo.wishes?.length || userId === myId) && (
                      <StyledTab
                        label={t('profile.wishes')}
                        {...a11yProps(2)}
                      />
                    )}
                  </SimpleTabs>
                </div>
                <div className={styles.sectionBody}>
                  <SwipeableViews
                    axis={isRtl ? 'x-reverse' : 'x'}
                    index={favIndex}
                    onChangeIndex={handleChangeFavIndex}
                  >
                    {userPersonalityCount
                      .filter(
                        (userPersonalityCount) =>
                          userPersonalityCount.value === true
                      )
                      .map((userPersonality, index) => {
                        return personalityTemplate(index, userPersonality.type);
                      })}
                  </SwipeableViews>
                </div>
              </div>
            </div>
          )}
      </div>
      <div className={styles.section}>
        <div className={styles.sectionTop}>
          <SimpleTabs value={tabIndex} handleChange={handleChange}>
            <StyledTab label={t('profile.receivedKudos')} {...a11yProps(0)} />
            <StyledTab label={t('profile.givenKudos')} {...a11yProps(1)} />
          </SimpleTabs>
        </div>
        <div className={classNames(styles.sectionBody, styles.noMargin)}>
          <SwipeableViews
            axis={isRtl ? 'x-reverse' : 'x'}
            index={tabIndex}
            onChangeIndex={handleChangeIndex}
            className={styles.swipeArea}
          >
            {tabIndex === 0 && (
              <InfiniteScroll
                next={receivedKudosFetchNextPage}
                dataLength={receivedKudosData ? receivedKudosData.length : 10}
                hasMore={receivedKudosHasNextPage}
                scrollThreshold={0.8}
                endMessage={<Eof />}
                loader={
                  !receivedKudosIsLoading && receivedKudosIsFetchingNextPage ? (
                    <Loader size={40} />
                  ) : (
                    <>
                      {receivedKudosHasNextPage &&
                        receivedKudosData.length >= 10 && (
                          <Button
                            fullWidth
                            variant="outlined"
                            onClick={givenKudosFetchNextPage}
                          >
                            {t('common.more')}
                          </Button>
                        )}
                    </>
                  )
                }
              >
                <TabPanel index={0} value={tabIndex}>
                  {receivedKudosIsLoading ? (
                    <Loader size={40} />
                  ) : receivedKudosData.length ? (
                    receivedKudosData.map((kudos) => (
                      <KudosCard
                        key={kudos.id}
                        extraClass={styles.kudosCard}
                        data={kudos}
                        isFetching={
                          givenKudosIsFetching || receivedKudosIsFetching
                        }
                      />
                    ))
                  ) : (
                    <div className={styles.empty}>
                      {userId === myId
                        ? t('profile.noReceivedMine')
                        : t('profile.noReceived', {
                            name: userInfo.first_name
                          })}
                    </div>
                  )}
                </TabPanel>
              </InfiniteScroll>
            )}
            {tabIndex === 1 && (
              <InfiniteScroll
                next={givenKudosFetchNextPage}
                dataLength={givenKudosData ? givenKudosData.length : 10}
                hasMore={givenKudosHasNextPage}
                scrollThreshold={0.8}
                endMessage={<Eof />}
                loader={
                  !givenKudosIsLoading && givenKudosIsFetchingNextPage ? (
                    <Loader size={40} />
                  ) : (
                    <>
                      {givenKudosHasNextPage && givenKudosData.length >= 10 && (
                        <Button
                          fullWidth
                          variant="outlined"
                          onClick={givenKudosFetchNextPage}
                        >
                          {t('common.more')}
                        </Button>
                      )}
                    </>
                  )
                }
              >
                <TabPanel index={1} value={tabIndex}>
                  {givenKudosIsLoading ? (
                    <Loader size={40} />
                  ) : givenKudosData.length ? (
                    givenKudosData.map((kudos, i) => (
                      <KudosCard
                        key={i}
                        extraClass={styles.kudosCard}
                        data={kudos}
                      />
                    ))
                  ) : (
                    <div className={styles.empty}>
                      {userId === myId
                        ? t('profile.noGivenMine')
                        : t('profile.noGiven', { name: userInfo.first_name })}
                    </div>
                  )}
                </TabPanel>
              </InfiniteScroll>
            )}
          </SwipeableViews>
        </div>

        <Backdrop
          mountOnEnter
          unmountOnExit
          open={openImage}
          style={{
            zIndex: 99999,
            backgroundColor: 'rgba(0, 0, 0, 0.8)'
          }}
          onClick={closeImage}
        >
          <img
            src={userInfo.avatar?.absolute_url}
            alt="profile"
            style={{
              width: '100vw',
              maxWidth: '600px'
            }}
          />
        </Backdrop>
      </div>
    </div>
  );
};

Profile.propTypes = {
  window: PropTypes.func,
  location: PropTypes.shape({
    pathname: PropTypes.string
  })
};

export default Profile;
